<template>
  <div>
    <InfoAlert :inline="true" type="offers" />
    <TopCategoryMenu />
    <CarouselBanner type="offers" />
    <div name="grid" class="flex justify-center mx-auto">
      <CategoryDropdownSidebar :type="CATEGORY_TYPE.ESHOP" />
      <main class="flex-1 sm:flex-none">
        <Feed :product-type="PRODUCT_TYPE.OFFER" :id-category="idCategory" />
      </main>
    </div>
    <CartCounterButton />
  </div>
</template>

<script setup>
import _ from 'lodash-es';
import { ROUTES } from "@utils/routes";
import { CATEGORY_TYPE } from "@utils/constants";
import { sitePages } from "@settings/site-pages.settings";
import { useCategoryStore } from '@stores/category';
import CarouselBanner from "@components/common/carousel-banner";
import CategoryDropdownSidebar from "@components/category/category-dropdown-sidebar";
import Feed from "@components/product/feed";
import CartCounterButton from "@components/cart/cart-counter-button";
import TopCategoryMenu from "@components/category/top-category-menu";

definePageMeta({
  layout: 'shop-layout'
});

defineI18nRoute({
  paths: {
    cs: '/nabidky/[slug]',
    en: '/offers/[slug]',
    sk: '/ponuky/[slug]',
    pl: '/oferty/[slug]',
    de: '/angeboten/[slug]'
  }
});

const config = useRuntimeConfig();
const route = useRoute();
const { t } = useI18n();

const idCategory = parseInt(route.params.slug);
const categories = useCategoryStore();
const category = categories.findEshop({ id: idCategory });
const canonical = config.public.appBaseUrl + translatePath(ROUTES.CODE.OFFERS, slugify(category?.id, category?.name));
const { title: seoTitle, ogUrl } = useFilterSeoTitle(() => t('nav-menu-offers'));

useHead({ link: [ { rel: 'canonical', href: canonical } ] });
useSeoMeta({
  title: () => seoTitle.value,
  ogTitle: () => seoTitle.value,
  description: `${t(sitePages[config.public.layoutDesign].offers[0].heading)} - ${t(sitePages[config.public.layoutDesign].offers[0].subheading).replace('<br>', ' ')}`,
  ogDescription: `${t(sitePages[config.public.layoutDesign].offers[0].heading)} - ${t(sitePages[config.public.layoutDesign].offers[0].subheading).replace('<br>', ' ')}`,
  ogImage: `${config.public.appBaseUrl}${sitePages[config.public.layoutDesign].offers[0].image}`,
  ogType: `${sitePages[config.public.layoutDesign].type}`,
  ogUrl: () => ogUrl.value
});

</script>
